import React from 'react'
import { FeeAmount } from '@uniswap/v3-sdk'
import { useTranslation } from 'react-i18next'
import { AutoColumn } from 'components/Column'
import { DynamicSection } from 'pages/AddLiquidity/styled'
import { TYPE } from 'theme'
import { AutoRow } from 'components/Row'
import { ButtonRadioChecked } from 'components/Button'
import styled from 'styled-components'

const ResponsiveText = styled(TYPE.label)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 12px;
  `};
`

export default function FeeSelector({
  disabled = false,
  feeAmount,
  handleFeePoolSelect,
}: {
  disabled?: boolean
  feeAmount?: FeeAmount
  handleFeePoolSelect: (feeAmount: FeeAmount) => void
}) {
  const { t } = useTranslation()

  return (
    <AutoColumn gap="16px">
      <DynamicSection gap="md" disabled={disabled}>
        <TYPE.label>{t('selectPool')}</TYPE.label>
        <TYPE.main fontSize={14} fontWeight={400} style={{ marginBottom: '.5rem', lineHeight: '125%' }}>
          Select a pool type based on your preferred liquidity provider fee.
        </TYPE.main>
        <AutoRow gap="2px">
          <ButtonRadioChecked
            width="48%"
            active={feeAmount === FeeAmount.LOWER}
            onClick={() => handleFeePoolSelect(FeeAmount.LOWER)}
          >
            <AutoColumn gap="sm" justify="flex-start">
              <ResponsiveText>0.01% {t('fee')}</ResponsiveText>
              <TYPE.main fontWeight={400} fontSize="12px" textAlign="left">
                Best for very stable pairs.
              </TYPE.main>
            </AutoColumn>
          </ButtonRadioChecked>
          <ButtonRadioChecked
            width="48%"
            active={feeAmount === FeeAmount.LOW}
            onClick={() => handleFeePoolSelect(FeeAmount.LOW)}
          >
            <AutoColumn gap="sm" justify="flex-start">
              <ResponsiveText>0.05% {t('fee')}</ResponsiveText>
              <TYPE.main fontWeight={400} fontSize="12px" textAlign="left">
                Best for stable pairs.
              </TYPE.main>
            </AutoColumn>
          </ButtonRadioChecked>
          <ButtonRadioChecked
            width="48%"
            active={feeAmount === FeeAmount.MEDIUM}
            onClick={() => handleFeePoolSelect(FeeAmount.MEDIUM)}
          >
            <AutoColumn gap="sm" justify="flex-start">
              <ResponsiveText>0.3% {t('fee')}</ResponsiveText>
              <TYPE.main fontWeight={400} fontSize="12px" textAlign="left">
                Best for most pairs.
              </TYPE.main>
            </AutoColumn>
          </ButtonRadioChecked>
          <ButtonRadioChecked
            width="48%"
            active={feeAmount === FeeAmount.HIGH}
            onClick={() => handleFeePoolSelect(FeeAmount.HIGH)}
          >
            <AutoColumn gap="sm" justify="flex-start">
              <ResponsiveText>1% {t('fee')}</ResponsiveText>
              <TYPE.main fontWeight={400} fontSize="12px" textAlign="left">
                Best for exotic pairs.
              </TYPE.main>
            </AutoColumn>
          </ButtonRadioChecked>
        </AutoRow>
      </DynamicSection>
    </AutoColumn>
  )
}
